import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { SunIcon, ExternalLinkIcon } from 'lucide-react';
export function Solar() {
  return <div className="space-y-6" data-id="element-1766">
      <header className="mb-6" data-id="element-1767">
        <div className="flex items-center gap-3 mb-2" data-id="element-1768">
          <div className="p-3 bg-amber-100 rounded-xl" data-id="element-1769">
            <SunIcon className="w-6 h-6 text-amber-700" data-id="element-1770" />
          </div>
          <div data-id="element-1771">
            <h1 className="text-4xl font-bold text-stone-900" data-id="element-1772">Solar</h1>
            <p className="text-stone-600" data-id="element-1773">Solar.dk regnskabssystem</p>
          </div>
        </div>
      </header>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} className="bg-white rounded-2xl border border-stone-200 shadow-sm overflow-hidden" data-id="element-1774">
        {/* Header with link */}
        <div className="p-4 border-b border-stone-200 bg-stone-50 flex items-center justify-between" data-id="element-1775">
          <div className="flex items-center gap-2" data-id="element-1776">
            <SunIcon className="w-5 h-5 text-amber-600" data-id="element-1777" />
            <span className="font-medium text-stone-900" data-id="element-1778">Solar.dk</span>
          </div>
          <a href="https://solar.dk" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-sm text-teal-600 hover:text-teal-700 transition-colors" data-id="element-1779">
            Åbn i nyt vindue
            <ExternalLinkIcon className="w-4 h-4" data-id="element-1780" />
          </a>
        </div>

        {/* Iframe container - MUCH BIGGER */}
        <div className="relative w-full" style={{
        height: 'calc(100vh - 200px)'
      }} data-id="element-1781">
          <iframe src="https://solar.dk" title="Solar.dk" className="w-full h-full border-0" sandbox="allow-same-origin allow-scripts allow-popups allow-forms" loading="lazy" data-id="element-1782" />
        </div>
      </motion.div>

      {/* Info box - smaller and more subtle */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.2,
      duration: 0.5
    }} className="bg-amber-50 border border-amber-200 rounded-lg p-3" data-id="element-1783">
        <p className="text-xs text-amber-900" data-id="element-1784">
          <strong data-id="element-1785">Bemærk:</strong> Dette er en indlejret visning af Solar.dk.
          For fuld funktionalitet kan du åbne siden i et nyt vindue ved at
          klikke på linket ovenfor.
        </p>
      </motion.div>
    </div>;
}